import { validationErrorLabelMap, getValidationErrorCodes } from './get-validation-error-codes.js';

const recoverableErrorCodes = [
    validationErrorLabelMap.IS_IN_STOCK,
    validationErrorLabelMap.IS_VALID_QUANTITY,
    validationErrorLabelMap.PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT, 
];
// Filter out all error codes that are considered "recoverable" from the
// validation errors fragment and return an array of the remaining error codes
const getUnrecoverableValidationErrors = (validationErrors)=>{
    if (!validationErrors) {
        return [];
    }
    const validationErrorCodes = getValidationErrorCodes(validationErrors);
    return validationErrorCodes.filter((code)=>!recoverableErrorCodes.includes(code)
    );
};

export { getUnrecoverableValidationErrors };
//# sourceMappingURL=get-unrecoverable-validation-errors.js.map
